var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showTooltip && this.options.hoveringTooltip
      ? _c("div", {
          staticClass: "datepicker__tooltip",
          domProps: { innerHTML: _vm._s(_vm.tooltipMessageDisplay) }
        })
      : _vm._e(),
    _c("div", {
      ref: "day",
      staticClass: "datepicker__month-day",
      class: _vm.dayClass,
      style: _vm.isToday ? _vm.currentDateStyle : "",
      attrs: { tabindex: _vm.tabIndex },
      domProps: { textContent: _vm._s(_vm.dayNumber) },
      on: {
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.dayClicked(_vm.date)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.dayClicked(_vm.date)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-54db7b9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54db7b9c","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Day.vue
// module id = 59
// module chunks = 0